import styled from 'styled-components'
import { belowTablet } from 'utilities/styled'
import Link from 'components/link'
import Modal from 'modals/dialog'
import Caption, { CaptionSmall } from 'components/typography/caption'
import ActionsBase from 'components/form/actions'

export const LoadingContainer = styled.div`
    height: 240px;
`

export const SubHeading = styled.div`
    margin-block-start: 8px;
`

export const HeadingLink = styled(Link)`
    display: flex;
    align-items: center;
    height: 24px;
`

export const ModalBody = styled(Modal.Body)`
    overflow-y: auto;

    margin-block-end: calc(var(--__huma-component-modal-row-gap) * -1);
`

export const Section = styled.div`
    &:not(:last-child) {
        margin-block-end: 24px;
    }
`

export const SectionHeading = styled(CaptionSmall)`
    margin-block-end: 8px;
    padding-inline: 32px;

    ${belowTablet`
        padding-inline: 24px;
    `}
`

export const Empty = styled(Caption)`
    padding-inline: 32px;

    ${belowTablet`
        padding-inline: 24px;
    `}
`

export const Actions = styled(ActionsBase)`
    padding: 24px 32px;
    border-top: 2px solid var(--huma-color-border-default);

    ${belowTablet`
        padding: 16px 24px;
    `}
`